import React from 'react';

import UserImage from '@core/components/userimage/UserImage';
import ColorBadge from '@core/components/colorbadge/ColorBadge';
import ExpertCoachingCta from '../expertcoachingcta/ExpertCoachingCta';

import LinkedinIcon from 'assets/icons/linkedin-outline.svg';

import classes from './ExpertProfileHero.module.scss';

const ExpertProfileHero = ({ expert }) => {
	if (!expert) return null;

	const fullName = [expert.first_name, expert.last_name].filter(Boolean).join(' ');

	return (
		<section className={classes['hero']}>
			<div className={classes['identity']}>
				<div className={classes['avatar']}>
					<UserImage imageURL={expert.image} />
				</div>

				<div className={classes['meta']}>
					<h1 className={classes['name']}>
						{fullName}
						{expert.linkedin_url && (
							<a
								className={classes['linkedin']}
								href={expert.linkedin_url}
								target='_blank'
								rel='noopener noreferrer'
								aria-label={`${fullName} on LinkedIn`}>
								<LinkedinIcon />
							</a>
						)}
					</h1>

					{expert.job_title && <p className={classes['job-title']}>{expert.job_title}</p>}

					{expert.years_of_experience > 0 && (
						<p className={classes['experience']}>
							{expert.years_of_experience} years of experience
						</p>
					)}

					{expert.badges?.length > 0 && (
						<div className={classes['badges']}>
							{expert.badges.map((badge) => (
								<ColorBadge key={badge.id} color={badge.color} label={badge.name} />
							))}
						</div>
					)}
				</div>
			</div>

			{expert.has_career_coaching && (
				<div className={classes['coaching-slot']}>
					<ExpertCoachingCta />
				</div>
			)}
		</section>
	);
};

export default ExpertProfileHero;
